import type { ListOption } from "@/types";

interface Props {
  buckets: ListOption[];
  /** The bucket the task sits in; picking it again is a no-op for a root task. */
  currentId?: string;
  /** Any pick promotes a subtask out of its parent, its own bucket included — so nothing is marked current. */
  isSubtask: boolean;
  onPick: (id: string) => void;
}

export default function BucketToggle({ buckets, currentId, isSubtask, onPick }: Props) {
  return (
    <div className="details-field">
      <svg className="w-4 h-4 flex-shrink-0 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
      <div className="flex gap-1" role="group" aria-label="Где лежит задача">
        {buckets.map((bucket) => {
          const current = !isSubtask && bucket.id === currentId;
          return (
            <button
              key={bucket.id}
              type="button"
              aria-pressed={current}
              onClick={() => {
                if (!current) onPick(bucket.id);
              }}
              className={`px-2 py-0.5 rounded-md text-sm cursor-pointer ${
                current
                  ? "bg-blue-50 text-blue-600 dark:bg-blue-950 dark:text-blue-400"
                  : "text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800"
              }`}
            >
              {bucket.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
